import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from '@components';
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from '@router/route.constants';

const {
    HOME,
    GAMES,
    NOTIFICATION,
    PROFILE,
} = PUBLIC_ROUTE;

const {
    WALLET,
} = PRIVATE_ROUTE;

const routes = [
    {
        path: GAMES,
        component: lazy(() => import('./Games/Games')),
        exact: true,
    },
    {
        path: WALLET,
        component: lazy(() => import('../WalletStack/Wallet/Wallet')),
        exact: true,
    },
    {
        path: NOTIFICATION,
        component: lazy(() => import('./Notification/Notification')),
        exact: true,
    },
    {
        path: PROFILE,
        component: lazy(() => import('./Profile/Profile')),
        exact: true,
    },
];

const HomeRoutes = () => {

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                {routes.map((route, idx) => (
                    <Route
                        key={idx}
                        exact={route.exact}
                        path={`${route.path}/*`}
                        element={<route.component />}
                    />
                ))}
                <Route
                    exact
                    path="*"
                    element={<Navigate to={`/${HOME}/${GAMES}`} />}
                />
            </Routes>
        </Suspense>
    );
};

export default HomeRoutes;
